import { render, staticRenderFns } from "./GraphPhotoAvatar.vue?vue&type=template&id=810d2ca6"
import script from "./GraphPhotoAvatar.vue?vue&type=script&lang=js"
export * from "./GraphPhotoAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('810d2ca6')) {
      api.createRecord('810d2ca6', component.options)
    } else {
      api.reload('810d2ca6', component.options)
    }
    module.hot.accept("./GraphPhotoAvatar.vue?vue&type=template&id=810d2ca6", function () {
      api.rerender('810d2ca6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GraphPhotoAvatar.vue"
export default component.exports